import { Component, inject } from '@angular/core';
import { IconMenuButtonComponent } from 'src/app/shared/components/icon-menu-button/icon-menu-button.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { PointOfSaleModel } from 'src/app/models/pointOfSale.model';
import { ToastService } from 'src/app/services/toast.service';
import { WorkloadsService } from 'src/app/services/workloads.service';
import { CommonFunctionsConfiguratorService } from 'src/app/shared/services/swal-fire-configurator.service';
import { PointSaleComponent } from '../point-sale/point-sale.component';
import { firstValueFrom } from 'rxjs';

import { MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { PageHeaderComponent } from 'src/app/shared/ui/page-header/page-header.component';
import { EmptyStateComponent } from 'src/app/shared/ui/empty-state/empty-state.component';

@Component({
    selector: 'app-point-sale-list',
    templateUrl: './point-sale-list.component.html',
    styleUrls: ['./point-sale-list.component.scss'],
    imports: [IconMenuButtonComponent, MatMenu, MatMenuItem, MatButton, MatIcon, PageHeaderComponent, EmptyStateComponent]
})
export class PointSaleListComponent {
  activatedRoute = inject(ActivatedRoute);
  private readonly router = inject(Router);
  franchiseSvc = inject(WorkloadsService);
  toastr = inject(ToastService);
  private readonly swalFire = inject(CommonFunctionsConfiguratorService);
  dialog = inject(MatDialog);

  public pointsOfSales: PointOfSaleModel[] = [];
  companyName: string = '';
  franchiseId: string = '';
  PointSaleComponent = PointSaleComponent;

  ngOnInit(): void {
    this.ngOnInitAsync();
  }

  private async ngOnInitAsync(): Promise<void> {
    this.franchiseId = await this.getPointSaleId();
    if (!this.franchiseId) {
      // Reached without a franchise (direct URL, reload after the id was dropped): there is nothing to list.
      this.router.navigate(['/franchises'], { replaceUrl: true });
      return;
    }
    this.getPointsOfSale(this.franchiseId);
  }

  async getPointSaleId() {
    const params = await firstValueFrom(this.activatedRoute.queryParams);
    let id = params['id'];
    this.companyName = params['companyName'];
    const { companyName, ...queryParams } = params;

    this.router.navigate(['.'], {
      relativeTo: this.activatedRoute,
      queryParams: queryParams,
      replaceUrl: true, // same page: no extra history entry for Back/Volver to land on
    });

    return id;
  }

  getPointsOfSale(franchiseId: string) {
    this.franchiseSvc.getFranchisePointOfSales(franchiseId).subscribe({
      next: (data) => {
        this.pointsOfSales = data;
      },
      error: (err) => {
        this.toastr.error(
          'Error',
          'No se pudo obtener los puntos de venta para la franquicia.'
        );
      },
    });
  }

  deletePointSale(posId: string) {
    this.swalFire
      .SwalFireQuestion(
        'Eliminar punto de venta',
        '¿Está seguro que desea eliminar el punto de venta?',
        'Eliminar',
        'Cancelar'
      )
      .then((result) => {
        if (result.isConfirmed) {
          this.franchiseSvc.deletePointOfSale(posId, false).subscribe({
            next: (result) => {
              this.toastr.success(
                'Punto de venta eliminado',
                'El punto de venta se ha eliminado correctamente.'
              );
              this.getPointsOfSale(this.franchiseId);
            },
            error: (err) => {
              this.toastr.error(
                'Error',
                'No se pudo eliminar el punto de venta.'
              );
            },
          });
        }
      });
  }

  dialogAction(pointOfSale?: PointOfSaleModel): void {
    if (pointOfSale) {
      const dialogRef = this.dialog.open(PointSaleComponent, {
        minWidth: '35vw',
        maxWidth: '95vw',
        data: {
          action: 'edit',
          selectedPOS: pointOfSale,
          franchiseId: this.franchiseId,
          companyName: this.companyName
        }
      });
      dialogRef.afterClosed().subscribe(() => {
        this.getPointsOfSale(this.franchiseId);
      });
    } else {
      this.franchiseSvc.getFranchiseById(this.franchiseId).subscribe({
        next: (data) => {
          const dialogRef = this.dialog.open(PointSaleComponent, {
            minWidth: '35vw',
            maxWidth: '95vw',
            data: {
              action: 'create',
              franchiseData: data
            }
          });
          dialogRef.afterClosed().subscribe(() => {
            this.getPointsOfSale(this.franchiseId);
          });
        },
        error: () => {
          this.toastr.error(
            'Error',
            'No se pudo obtener la información de la franquicia.'
          );
        }
      });
    }
  }

}
